import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

export default function AppShell() {
  return (
    <div className="min-h-screen flex bg-[#F7F7F8]" data-testid="app-shell">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 md:ml-64">
        <Header />
        <main className="flex-1 px-6 md:px-8 py-8 max-w-[1600px] w-full mx-auto fade-up min-w-0 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
